// CommonJS de propósito: usado pelo vue.config.js (Node) e pelo bundle. Regras: docs/multiplo-web/plugins/envParceiro.md
function ambienteValido (ambiente) {
  return typeof ambiente === 'string' && /^[a-z0-9_]+$/i.test(ambiente)
}

function definido (valor) {
  return valor && valor !== 'default' ? valor : null
}

function resolverParceiroBuild ({ env, argumento, pastas, comando }) {
  const comandoCli = comando === 'build' || comando === 'serve'
  let customizacao = definido(env.VUE_APP_CUSTOMIZACAO)

  if (customizacao && comandoCli && !pastas.includes(customizacao)) {
    throw new Error(`VUE_APP_CUSTOMIZACAO "${customizacao}" não é uma pasta de Multiplo.Web (na pipeline, confira a variável projectNameCore). Use uma destas: ${pastas.join(', ')}`)
  }

  if (!customizacao && argumento) {
    if (pastas.includes(argumento)) {
      customizacao = argumento
    } else if (comandoCli) {
      throw new Error(`Pasta de customização "${argumento}" não existe em Multiplo.Web. Use uma destas: ${pastas.join(', ')}`)
    }
  }
  customizacao = customizacao || 'default'

  return { customizacao, ambiente: definido(env.VUE_APP_AMBIENTE) || customizacao }
}

module.exports = { ambienteValido, resolverParceiroBuild }
